var Ge = Object.defineProperty;
var be = (t) => {
  throw TypeError(t);
};
var Je = (t, a, s) => a in t ? Ge(t, a, { enumerable: !0, configurable: !0, writable: !0, value: s }) : t[a] = s;
var Z = (t, a, s) => Je(t, typeof a != "symbol" ? a + "" : a, s), Qe = (t, a, s) => a.has(t) || be("Cannot " + s);
var X = (t, a, s) => (Qe(t, a, "read from private field"), s ? s.call(t) : a.get(t)), Y = (t, a, s) => a.has(t) ? be("Cannot add the same private member more than once") : a instanceof WeakSet ? a.add(t) : a.set(t, s);
import { j as e } from "./jsx-runtime-Bdg6XQ1m.js";
import { m as We } from "./chunk-SYFQ2XB5-BF5IDYrB.js";
import { i as Ke, j as Ne, k as Ze } from "./ZudokuContext-DeQZEp-x.js";
import { Circle as Xe, ChevronRightIcon as Ye, CheckIcon as et, DotIcon as tt, Check as at, Search as st, XIcon as nt, EraserIcon as rt, ChevronsUpDownIcon as ot, InfoIcon as we, LogInIcon as lt, CirclePlayIcon as it } from "lucide-react";
import { u as dt } from "./hook-BRQEDRbn.js";
import { Button as E } from "./ui/Button.js";
import { Z as ct } from "./invariant-Caa8-XvF.js";
import { VisuallyHidden as mt } from "@radix-ui/react-visually-hidden";
import * as u from "react";
import { useRef as V, useEffect as Re, useState as B, useTransition as ut, Fragment as ee } from "react";
import { V as j, T as pt, D as ht, b as ft, a as xt, c as gt } from "./index-B7mqiOei.js";
import { u as yt, S as vt, a as jt, b as bt, c as Nt, e as wt } from "./Select-D3O7wISy.js";
import { b as me, u as $e, C as T, a as Ct, F as St } from "./index.esm-CrSoEshU.js";
import { c as ue } from "./index-Djenk2Hj.js";
import { c as d } from "./cn-qaFjX9_3.js";
import * as ke from "@radix-ui/react-label";
import * as L from "@radix-ui/react-radio-group";
import { a as Tt } from "./state-mM7uaXTW.js";
import { B as Pt, S as Rt } from "./Spinner-BlzrEEk1.js";
import { Callout as $t } from "./ui/Callout.js";
import { Card as U, CardHeader as kt, CardTitle as It, CardContent as Et } from "./ui/Card.js";
import { Tabs as Ce, TabsList as Se, TabsTrigger as k, TabsContent as I } from "./ui/Tabs.js";
import { z as Ot, S as qt } from "./SyntaxHighlight-CJCSPG1F.js";
import * as x from "@radix-ui/react-dropdown-menu";
import * as re from "@radix-ui/react-checkbox";
import * as G from "@radix-ui/react-popover";
import { PopoverAnchor as At } from "@radix-ui/react-popover";
import { Input as pe } from "./ui/Input.js";
import { Slot as Dt } from "@radix-ui/react-slot";
class z extends String {
  constructor(s, r) {
    super(s);
    Z(this, "__apiType");
    this.value = s, this.__meta__ = r;
  }
  toString() {
    return this.value;
  }
}
const Vt = new z(
  `
    fragment OperationsFragment on OperationItem {
  slug
  summary
  method
  description
  operationId
  contentTypes
  path
  parameters {
    name
    in
    description
    required
    schema
    style
    examples {
      name
      description
      externalValue
      value
      summary
    }
  }
  requestBody {
    content {
      mediaType
      encoding {
        name
      }
      examples {
        name
        description
        externalValue
        value
        summary
      }
      schema
    }
    description
    required
  }
  responses {
    statusCode
    links
    description
    content {
      examples {
        name
        description
        externalValue
        value
        summary
      }
      mediaType
      encoding {
        name
      }
      schema
    }
  }
}
    `,
  { fragmentName: "OperationsFragment" }
), Lt = new z(`
    query ServersQuery($input: JSON!, $type: SchemaType!) {
  schema(input: $input, type: $type) {
    url
    servers {
      url
    }
  }
}
    `), zt = new z(`
    query AllOperations($input: JSON!, $type: SchemaType!) {
  schema(input: $input, type: $type) {
    description
    summary
    title
    url
    version
    tags {
      name
      description
      operations {
        slug
        ...OperationsFragment
      }
    }
  }
}
    fragment OperationsFragment on OperationItem {
  slug
  summary
  method
  description
  operationId
  contentTypes
  path
  parameters {
    name
    in
    description
    required
    schema
    style
    examples {
      name
      description
      externalValue
      value
      summary
    }
  }
  requestBody {
    content {
      mediaType
      encoding {
        name
      }
      examples {
        name
        description
        externalValue
        value
        summary
      }
      schema
    }
    description
    required
  }
  responses {
    statusCode
    links
    description
    content {
      examples {
        name
        description
        externalValue
        value
        summary
      }
      mediaType
      encoding {
        name
      }
      schema
    }
  }
}`), _t = new z(`
    query getServerQuery($input: JSON!, $type: SchemaType!) {
  schema(input: $input, type: $type) {
    url
    servers {
      url
    }
  }
}
    `), Mt = new z(`
    query GetCategories($input: JSON!, $type: SchemaType!) {
  schema(input: $input, type: $type) {
    url
    tags {
      __typename
      name
      operations {
        __typename
        slug
        deprecated
        method
        summary
        operationId
        path
      }
    }
  }
}
    `), Ft = {
  "\n  query ServersQuery($input: JSON!, $type: SchemaType!) {\n    schema(input: $input, type: $type) {\n      url\n      servers {\n        url\n      }\n    }\n  }\n": Lt,
  "\n  fragment OperationsFragment on OperationItem {\n    slug\n    summary\n    method\n    description\n    operationId\n    contentTypes\n    path\n    parameters {\n      name\n      in\n      description\n      required\n      schema\n      style\n      examples {\n        name\n        description\n        externalValue\n        value\n        summary\n      }\n    }\n    requestBody {\n      content {\n        mediaType\n        encoding {\n          name\n        }\n        examples {\n          name\n          description\n          externalValue\n          value\n          summary\n        }\n        schema\n      }\n      description\n      required\n    }\n    responses {\n      statusCode\n      links\n      description\n      content {\n        examples {\n          name\n          description\n          externalValue\n          value\n          summary\n        }\n        mediaType\n        encoding {\n          name\n        }\n        schema\n      }\n    }\n  }\n": Vt,
  "\n  query AllOperations($input: JSON!, $type: SchemaType!) {\n    schema(input: $input, type: $type) {\n      description\n      summary\n      title\n      url\n      version\n      tags {\n        name\n        description\n        operations {\n          slug\n          ...OperationsFragment\n        }\n      }\n    }\n  }\n": zt,
  "\n  query getServerQuery($input: JSON!, $type: SchemaType!) {\n    schema(input: $input, type: $type) {\n      url\n      servers {\n        url\n      }\n    }\n  }\n": _t,
  "\n  query GetCategories($input: JSON!, $type: SchemaType!) {\n    schema(input: $input, type: $type) {\n      url\n      tags {\n        __typename\n        name\n        operations {\n          __typename\n          slug\n          deprecated\n          method\n          summary\n          operationId\n          path\n        }\n      }\n    }\n  }\n": Mt
};
function Ht(t) {
  return Ft[t] ?? {};
}
let te;
const Ut = (t) => {
  var a;
  if ((a = t.errors) != null && a[0])
    throw new ct(t.errors[0].message, {
      developerHint: "Check your configuration value `apis.type` and `apis.input` in the Zudoku config."
    });
};
var J, Q;
class Bt {
  constructor(a) {
    Y(this, J, async () => (te || (te = import("./createServer-BcaswoFO.js").then(
      (a) => a.createServer(this.config)
    )), te));
    Y(this, Q, async (a) => this.config.server ? fetch(this.config.server, a) : (await X(this, J).call(this)).fetch("http://localhost/graphql", a));
    Z(this, "fetch", async (a, ...[s]) => {
      var i;
      const r = (i = a.match(/query (\w+)/)) == null ? void 0 : i[1], o = await X(this, Q).call(this, {
        method: "POST",
        body: JSON.stringify({ query: a, variables: s, operationName: r }),
        headers: { "Content-Type": "application/json" }
      });
      if (!o.ok)
        throw new Error("Network response was not ok");
      const l = await o.json();
      return Ut(l), l.data;
    });
    this.config = a;
  }
}
J = new WeakMap(), Q = new WeakMap();
const Gt = ue(
  "relative w-full rounded-lg border p-4 [&>svg~*]:pl-7 [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg]:text-foreground",
  {
    variants: {
      variant: {
        default: "bg-background text-foreground",
        destructive: "border-destructive/50 text-destructive dark:border-destructive [&>svg]:text-destructive"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), oe = u.forwardRef(({ className: t, variant: a, ...s }, r) => /* @__PURE__ */ e.jsx(
  "div",
  {
    ref: r,
    role: "alert",
    className: d(Gt({ variant: a }), t),
    ...s
  }
));
oe.displayName = "Alert";
const le = u.forwardRef(({ className: t, ...a }, s) => /* @__PURE__ */ e.jsx(
  "h5",
  {
    ref: s,
    className: d("mb-1 font-medium leading-none tracking-tight", t),
    ...a
  }
));
le.displayName = "AlertTitle";
const ie = u.forwardRef(({ className: t, ...a }, s) => /* @__PURE__ */ e.jsx(
  "div",
  {
    ref: s,
    className: d("text-sm [&_p]:leading-relaxed", t),
    ...a
  }
));
ie.displayName = "AlertDescription";
const Jt = ue(
  "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
), D = u.forwardRef(({ className: t, ...a }, s) => /* @__PURE__ */ e.jsx(
  ke.Root,
  {
    ref: s,
    className: d(Jt(), t),
    ...a
  }
));
D.displayName = ke.Root.displayName;
const Ie = u.forwardRef(({ className: t, ...a }, s) => /* @__PURE__ */ e.jsx(
  L.Root,
  {
    className: d("grid gap-2", t),
    ...a,
    ref: s
  }
));
Ie.displayName = L.Root.displayName;
const de = u.forwardRef(({ className: t, ...a }, s) => /* @__PURE__ */ e.jsx(
  L.Item,
  {
    ref: s,
    className: d(
      "aspect-square h-4 w-4 rounded-full border border-primary text-primary ring-offset-background focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
      t
    ),
    ...a,
    children: /* @__PURE__ */ e.jsx(L.Indicator, { className: "flex items-center justify-center", children: /* @__PURE__ */ e.jsx(Xe, { className: "h-2.5 w-2.5 fill-current text-current" }) })
  }
));
de.displayName = L.Item.displayName;
const Ee = u.forwardRef(
  ({ className: t, ...a }, s) => /* @__PURE__ */ e.jsx(
    "textarea",
    {
      className: d(
        "flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        t
      ),
      ref: s,
      ...a
    }
  )
);
Ee.displayName = "Textarea";
const ae = (t) => Math.abs(
  isNaN(parseInt(t)) ? t.toLowerCase().charCodeAt(0) - 96 : isNaN(parseInt(t)) ? 0 : parseInt(t)
), se = (t) => t.length > 1 ? parseInt(t.split("").reduce((a, s) => `${ae(a) + ae(s)}`)) : ae(t), Te = (t, a = {}) => {
  const s = (3 * se(t) + 2 * se(t) + se(t)) % 360, { saturation: r = 75, lightness: o = 60 } = a;
  return `${s}deg ${r}% ${o}%`;
}, ne = "data-linked-param", Oe = (t) => {
  const { resolvedTheme: a } = Ot();
  return {
    text: Te(
      t,
      a === "light" ? { saturation: 95, lightness: 38 } : {}
    ),
    background: Te(
      t,
      a === "light" ? { saturation: 85, lightness: 40 } : {}
    )
  };
}, Qt = (t) => {
  const a = t.replace(/[{}]/g, "");
  return Oe(a);
}, qe = ({
  name: t,
  className: a,
  slug: s,
  title: r,
  children: o,
  onClick: l
}) => {
  const i = V(null), p = s == null ? void 0 : s.replace(/[{}]/g, ""), c = t.replace(/[{}]/g, ""), { text: h, background: g } = Oe(c), b = `hsl(${h} / 100%)`, f = `hsl(${g} / 10%)`, m = `hsl(${g} / 50%)`;
  return Re(() => {
    if (!p || !i.current) return;
    const y = () => {
      document.querySelectorAll(`[${ne}="${p}"]`).forEach((P) => {
        P instanceof HTMLElement && (P.dataset.active = "true");
      });
    }, O = () => {
      document.querySelectorAll(`[${ne}="${p}"]`).forEach((P) => {
        P instanceof HTMLElement && (P.dataset.active = "false");
      });
    }, C = i.current;
    return C.addEventListener("mouseenter", y), C.addEventListener("mouseleave", O), () => {
      C.removeEventListener("mouseenter", y), C.removeEventListener("mouseleave", O);
    };
  }, [p]), /* @__PURE__ */ e.jsx(
    "span",
    {
      [ne]: p,
      className: d(
        "relative inline-block rounded transition-all duration-100",
        "rounded-lg",
        "border border-[--border-color] p-0.5 text-[--param-color] bg-[--background-color]",
        "data-[active=true]:border-[--param-color] data-[active=true]:shadow data-[active=true]:-translate-y-px",
        a
      ),
      title: r,
      suppressHydrationWarning: !0,
      ref: i,
      onClick: l,
      style: {
        "--param-color": b,
        "--border-color": m,
        "--background-color": f
      },
      children: o ?? t
    }
  );
}, Wt = (t, a, s) => {
  const r = a.replace(/(:\w+|\{\w+})/g, (l) => {
    var c;
    const i = l.replace(/[:{}]/g, "");
    return ((c = s.pathParams.find((h) => h.name === i)) == null ? void 0 : c.value) ?? l;
  }), o = new URL(
    r.replace(/^\//, ""),
    t.endsWith("/") ? t : `${t}/`
  );
  return s.queryParams.filter((l) => l.active).forEach((l) => {
    o.searchParams.set(l.name, l.value);
  }), o;
}, Kt = x.Root, Zt = x.Trigger, Xt = x.Group, Yt = u.forwardRef(({ className: t, inset: a, children: s, ...r }, o) => /* @__PURE__ */ e.jsxs(
  x.SubTrigger,
  {
    ref: o,
    className: d(
      "flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none focus:bg-accent data-[state=open]:bg-accent",
      a && "pl-8",
      t
    ),
    ...r,
    children: [
      s,
      /* @__PURE__ */ e.jsx(Ye, { className: "ml-auto h-4 w-4" })
    ]
  }
));
Yt.displayName = x.SubTrigger.displayName;
const ea = u.forwardRef(({ className: t, ...a }, s) => /* @__PURE__ */ e.jsx(
  x.SubContent,
  {
    ref: s,
    className: d(
      "z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      t
    ),
    ...a
  }
));
ea.displayName = x.SubContent.displayName;
const Ae = u.forwardRef(({ className: t, sideOffset: a = 4, ...s }, r) => /* @__PURE__ */ e.jsx(x.Portal, { children: /* @__PURE__ */ e.jsx(
  x.Content,
  {
    ref: r,
    sideOffset: a,
    className: d(
      "z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-md",
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      t
    ),
    ...s
  }
) }));
Ae.displayName = x.Content.displayName;
const De = u.forwardRef(({ className: t, inset: a, ...s }, r) => /* @__PURE__ */ e.jsx(
  x.Item,
  {
    ref: r,
    className: d(
      "relative flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      a && "pl-8",
      t
    ),
    ...s
  }
));
De.displayName = x.Item.displayName;
const ta = u.forwardRef(({ className: t, children: a, checked: s, ...r }, o) => /* @__PURE__ */ e.jsxs(
  x.CheckboxItem,
  {
    ref: o,
    className: d(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      t
    ),
    checked: s,
    ...r,
    children: [
      /* @__PURE__ */ e.jsx("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ e.jsx(x.ItemIndicator, { children: /* @__PURE__ */ e.jsx(et, { className: "h-4 w-4" }) }) }),
      a
    ]
  }
));
ta.displayName = x.CheckboxItem.displayName;
const aa = u.forwardRef(({ className: t, children: a, ...s }, r) => /* @__PURE__ */ e.jsxs(
  x.RadioItem,
  {
    ref: r,
    className: d(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      t
    ),
    ...s,
    children: [
      /* @__PURE__ */ e.jsx("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ e.jsx(x.ItemIndicator, { children: /* @__PURE__ */ e.jsx(tt, { className: "h-4 w-4 fill-current" }) }) }),
      a
    ]
  }
));
aa.displayName = x.RadioItem.displayName;
const Ve = u.forwardRef(({ className: t, inset: a, ...s }, r) => /* @__PURE__ */ e.jsx(
  x.Label,
  {
    ref: r,
    className: d(
      "px-2 py-1.5 text-sm font-semibold",
      a && "pl-8",
      t
    ),
    ...s
  }
));
Ve.displayName = x.Label.displayName;
const Le = u.forwardRef(({ className: t, ...a }, s) => /* @__PURE__ */ e.jsx(
  x.Separator,
  {
    ref: s,
    className: d("-mx-1 my-1 h-px bg-muted", t),
    ...a
  }
));
Le.displayName = x.Separator.displayName;
const sa = ({
  examples: t,
  onSelect: a
}) => /* @__PURE__ */ e.jsxs(Kt, { children: [
  /* @__PURE__ */ e.jsx(Zt, { asChild: !0, children: /* @__PURE__ */ e.jsx(Pt, { variant: "outline", children: "Use Example" }) }),
  /* @__PURE__ */ e.jsx(Ae, { className: "w-56", children: t.map((s) => {
    var r;
    return /* @__PURE__ */ e.jsxs("div", { children: [
      /* @__PURE__ */ e.jsx(Ve, { children: s.mediaType }),
      /* @__PURE__ */ e.jsx(Le, {}),
      /* @__PURE__ */ e.jsx(Xt, { children: (r = s.examples) == null ? void 0 : r.map((o) => /* @__PURE__ */ e.jsx(
        De,
        {
          onSelect: () => a(o),
          children: o.name
        },
        o.name
      )) })
    ] }, s.mediaType);
  }) })
] }), W = u.forwardRef(({ className: t, ...a }, s) => /* @__PURE__ */ e.jsx(
  "div",
  {
    ref: s,
    className: d(
      "rounded-xl border bg-card text-card-foreground shadow-sm",
      t
    ),
    ...a
  }
));
W.displayName = "Card";
const na = u.forwardRef(({ className: t, ...a }, s) => /* @__PURE__ */ e.jsx(
  "div",
  {
    ref: s,
    className: d("flex flex-col space-y-1.5 p-6", t),
    ...a
  }
));
na.displayName = "CardHeader";
const ra = u.forwardRef(({ className: t, ...a }, s) => /* @__PURE__ */ e.jsx(
  "h3",
  {
    ref: s,
    className: d("font-semibold leading-none tracking-tight", t),
    ...a
  }
));
ra.displayName = "CardTitle";
const oa = u.forwardRef(({ className: t, ...a }, s) => /* @__PURE__ */ e.jsx(
  "p",
  {
    ref: s,
    className: d("text-sm text-muted-foreground", t),
    ...a
  }
));
oa.displayName = "CardDescription";
const la = u.forwardRef(({ className: t, ...a }, s) => /* @__PURE__ */ e.jsx("div", { ref: s, className: d("p-6 pt-0", t), ...a }));
la.displayName = "CardContent";
const ia = u.forwardRef(({ className: t, ...a }, s) => /* @__PURE__ */ e.jsx(
  "div",
  {
    ref: s,
    className: d("flex items-center p-6 pt-0", t),
    ...a
  }
));
ia.displayName = "CardFooter";
const da = ue(
  "peer h-4 w-4 shrink-0 rounded-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:text-primary",
  {
    variants: {
      variant: {
        default: "border border-primary data-[state=checked]:bg-primary",
        outline: "border border-input data-[state=checked]:bg-accent"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), he = u.forwardRef(({ className: t, variant: a, ...s }, r) => /* @__PURE__ */ e.jsx(
  re.Root,
  {
    ref: r,
    className: d(da({ variant: a, className: t })),
    ...s,
    children: /* @__PURE__ */ e.jsx(
      re.Indicator,
      {
        className: d("flex items-center justify-center text-current"),
        children: /* @__PURE__ */ e.jsx(at, { className: "h-4 w-4" })
      }
    )
  }
));
he.displayName = re.Root.displayName;
const ze = u.forwardRef(({ className: t, ...a }, s) => /* @__PURE__ */ e.jsx(
  j,
  {
    ref: s,
    className: d(
      "flex h-full w-full flex-col overflow-hidden rounded-md bg-popover text-popover-foreground",
      t
    ),
    ...a
  }
));
ze.displayName = j.displayName;
const ca = u.forwardRef(({ className: t, ...a }, s) => (
  // eslint-disable-next-line react/no-unknown-property
  /* @__PURE__ */ e.jsxs("div", { className: "flex items-center border-b px-3", "cmdk-input-wrapper": "", children: [
    /* @__PURE__ */ e.jsx(st, { className: "mr-2 h-4 w-4 shrink-0 opacity-50" }),
    /* @__PURE__ */ e.jsx(
      j.Input,
      {
        ref: s,
        className: d(
          "flex h-11 w-full rounded-md bg-transparent py-3 text-sm outline-none placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50",
          t
        ),
        ...a
      }
    )
  ] })
));
ca.displayName = j.Input.displayName;
const _e = u.forwardRef(({ className: t, ...a }, s) => (
  // eslint-disable-next-line react/no-unknown-property
  /* @__PURE__ */ e.jsx("div", { className: "flex items-center", "cmdk-input-wrapper": "", children: /* @__PURE__ */ e.jsx(
    j.Input,
    {
      ref: s,
      className: d(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
        "focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring",
        t
      ),
      ...a
    }
  ) })
));
_e.displayName = j.Input.displayName;
const Me = u.forwardRef(({ className: t, ...a }, s) => /* @__PURE__ */ e.jsx(
  j.List,
  {
    ref: s,
    className: d("max-h-[300px] overflow-y-auto overflow-x-hidden", t),
    ...a
  }
));
Me.displayName = j.List.displayName;
const ma = u.forwardRef((t, a) => /* @__PURE__ */ e.jsx(
  j.Empty,
  {
    ref: a,
    className: "py-6 text-center text-sm",
    ...t
  }
));
ma.displayName = j.Empty.displayName;
const ua = u.forwardRef(({ className: t, ...a }, s) => /* @__PURE__ */ e.jsx(
  j.Group,
  {
    ref: s,
    className: d(
      "overflow-hidden p-1 text-foreground [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground",
      t
    ),
    ...a
  }
));
ua.displayName = j.Group.displayName;
const pa = u.forwardRef(({ className: t, ...a }, s) => /* @__PURE__ */ e.jsx(
  j.Separator,
  {
    ref: s,
    className: d("-mx-1 h-px bg-border", t),
    ...a
  }
));
pa.displayName = j.Separator.displayName;
const Fe = u.forwardRef(({ className: t, ...a }, s) => /* @__PURE__ */ e.jsx(
  j.Item,
  {
    ref: s,
    className: d(
      "relative flex cursor-default gap-2 select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none data-[disabled=true]:pointer-events-none data-[selected='true']:bg-accent data-[selected=true]:text-accent-foreground data-[disabled=true]:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
      t
    ),
    ...a
  }
));
Fe.displayName = j.Item.displayName;
const ha = G.Root, He = u.forwardRef(({ className: t, align: a = "center", sideOffset: s = 4, ...r }, o) => /* @__PURE__ */ e.jsx(G.Portal, { children: /* @__PURE__ */ e.jsx(
  G.Content,
  {
    ref: o,
    align: a,
    sideOffset: s,
    className: d(
      "z-50 w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      t
    ),
    ...r
  }
) }));
He.displayName = G.Content.displayName;
const fa = ({
  value: t,
  options: a,
  onChange: s,
  className: r,
  placeholder: o = "Enter value",
  onEnterPress: l,
  ref: i
}) => {
  const [p, c] = B(!1), [h, g] = B(!1), b = pt((m) => m.filtered.count), f = V(null);
  return /* @__PURE__ */ e.jsxs(ha, { open: p, children: [
    /* @__PURE__ */ e.jsx(At, { children: /* @__PURE__ */ e.jsx(
      _e,
      {
        ref: (m) => {
          f.current = m, typeof i == "function" ? i(m) : i && (i.current = m);
        },
        value: t,
        placeholder: o,
        className: d("h-9 bg-transparent", r),
        onFocus: () => c(!0),
        onBlur: () => {
          h || c(!1);
        },
        onKeyDown: (m) => {
          var y;
          m.key === "Enter" && (c(!1), (y = f.current) == null || y.blur(), l == null || l(m));
        },
        onValueChange: (m) => s(m)
      }
    ) }),
    /* @__PURE__ */ e.jsx(
      He,
      {
        onMouseEnter: () => g(!0),
        onMouseLeave: () => g(!1),
        onOpenAutoFocus: (m) => m.preventDefault(),
        className: d("p-0 w-[--radix-popover-trigger-width]", {
          "border-0": b === 0
        }),
        align: "start",
        side: "bottom",
        onWheel: (m) => {
          m.stopPropagation();
        },
        onTouchMove: (m) => {
          m.stopPropagation();
        },
        children: /* @__PURE__ */ e.jsx(Me, { className: "max-h-[140px]", children: a.map((m) => /* @__PURE__ */ e.jsx(
          Fe,
          {
            value: m,
            onSelect: (y) => {
              s(y), c(!1);
            },
            className: "cursor-pointer",
            children: m
          },
          m
        )) })
      }
    )
  ] });
}, ce = (t) => /* @__PURE__ */ e.jsx(ze, { className: "bg-transparent", children: /* @__PURE__ */ e.jsx(fa, { ...t }) }), xa = Object.freeze([
  "Accept",
  "Accept-Encoding",
  "Accept-Language",
  "Authorization",
  "Cache-Control",
  "Connection",
  "Content-Disposition",
  "Content-Encoding",
  "Content-Language",
  "Content-Length",
  "Content-Range",
  "Content-Security-Policy",
  "Content-Type",
  "Cookie",
  "Date",
  "ETag",
  "Expires",
  "Host",
  "If-Modified-Since",
  "Location",
  "Origin",
  "Pragma",
  "Referer",
  "Set-Cookie",
  "User-Agent",
  "X-Requested-With"
]), ga = ({
  control: t,
  register: a
}) => {
  const { fields: s, append: r, remove: o } = me({
    control: t,
    name: "headers"
  }), { setValue: l } = $e(), i = V([]), p = V([]), c = () => {
    r({
      name: "",
      value: "",
      active: !1
    });
  }, h = (b) => {
    var f;
    (f = i.current[b]) == null || f.focus();
  }, g = (b) => {
    c(), requestAnimationFrame(() => {
      var f;
      return (f = p.current[b + 1]) == null ? void 0 : f.focus();
    });
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-2", children: [
    /* @__PURE__ */ e.jsx(W, { className: "flex flex-col gap-2 overflow-hidden", children: /* @__PURE__ */ e.jsx("table", { className: "w-full", children: /* @__PURE__ */ e.jsx("tbody", { children: s.map((b, f) => /* @__PURE__ */ e.jsxs(
      "tr",
      {
        className: "group has-[:focus]:bg-muted/50 hover:bg-muted/50",
        children: [
          /* @__PURE__ */ e.jsxs("td", { className: "flex gap-2 items-center pl-3", children: [
            /* @__PURE__ */ e.jsx(
              T,
              {
                control: t,
                name: `headers.${f}.active`,
                render: ({ field: m }) => /* @__PURE__ */ e.jsx(
                  he,
                  {
                    variant: "outline",
                    id: `headers.${f}.active`,
                    checked: m.value,
                    onCheckedChange: (y) => {
                      m.onChange(y);
                    }
                  }
                )
              }
            ),
            /* @__PURE__ */ e.jsx(
              T,
              {
                control: t,
                name: `headers.${f}.name`,
                render: ({ field: m }) => /* @__PURE__ */ e.jsx(
                  ce,
                  {
                    ...m,
                    placeholder: "Name",
                    className: "border-0 shadow-none bg-transparent text-xs font-mono",
                    options: xa,
                    onEnterPress: () => h(f),
                    onChange: (y) => {
                      m.onChange(y), l(`headers.${f}.active`, !0);
                    },
                    ref: (y) => {
                      p.current[f] = y;
                    }
                  }
                )
              }
            )
          ] }),
          /* @__PURE__ */ e.jsx("td", { children: /* @__PURE__ */ e.jsxs("div", { className: "flex items-center gap-2", children: [
            /* @__PURE__ */ e.jsx(
              pe,
              {
                placeholder: "Value",
                className: "w-full border-0 shadow-none text-xs font-mono",
                ...a(`headers.${f}.value`),
                ref: (m) => {
                  i.current[f] = m;
                },
                onKeyDown: (m) => {
                  m.key === "Enter" && m.currentTarget.value.trim() && g(f);
                },
                autoComplete: "off"
              }
            ),
            /* @__PURE__ */ e.jsx(
              E,
              {
                size: "icon",
                variant: "ghost",
                className: "text-muted-foreground opacity-0 group-hover:opacity-100",
                onClick: () => {
                  o(f);
                },
                type: "button",
                children: /* @__PURE__ */ e.jsx(nt, { size: 16 })
              }
            )
          ] }) })
        ]
      },
      b.id
    )) }) }) }),
    /* @__PURE__ */ e.jsx("div", { className: "text-end", children: /* @__PURE__ */ e.jsx(
      E,
      {
        className: "",
        onClick: c,
        type: "button",
        variant: "secondary",
        children: "Add header"
      }
    ) })
  ] });
}, ya = ({ name: t }) => {
  const a = Qt(t);
  return /* @__PURE__ */ e.jsxs("div", { className: "flex items-center", children: [
    /* @__PURE__ */ e.jsx(
      "div",
      {
        className: "w-2 h-2 rounded-full",
        style: { backgroundColor: `hsl(${a})` }
      }
    ),
    /* @__PURE__ */ e.jsx(
      qe,
      {
        slug: t,
        name: t,
        className: "font-mono text-xs m-2 px-1"
      }
    )
  ] });
}, va = ({
  control: t
}) => {
  const { fields: a } = me({
    control: t,
    name: "pathParams"
  });
  return /* @__PURE__ */ e.jsx(W, { className: "rounded-lg", children: /* @__PURE__ */ e.jsx("table", { className: "w-full", children: /* @__PURE__ */ e.jsx("tbody", { children: a.map((s, r) => /* @__PURE__ */ e.jsxs("tr", { className: "hover:bg-accent/40", children: [
    /* @__PURE__ */ e.jsx("td", { className: "w-5/12", children: /* @__PURE__ */ e.jsx(
      T,
      {
        control: t,
        name: `pathParams.${r}.value`,
        render: () => /* @__PURE__ */ e.jsx(ya, { name: s.name })
      }
    ) }),
    /* @__PURE__ */ e.jsx("td", { className: "w-7/12", children: /* @__PURE__ */ e.jsxs("div", { className: "flex justify-between items-center", children: [
      /* @__PURE__ */ e.jsx(
        T,
        {
          control: t,
          name: `pathParams.${r}.value`,
          render: ({ field: o }) => /* @__PURE__ */ e.jsx(
            pe,
            {
              ...o,
              required: !0,
              placeholder: "Enter value",
              className: "w-full border-0 shadow-none text-xs font-mono hover:bg-accent"
            }
          )
        }
      ),
      /* @__PURE__ */ e.jsx(
        T,
        {
          control: t,
          name: `pathParams.${r}.value`,
          render: ({ field: o }) => /* @__PURE__ */ e.jsx(
            E,
            {
              size: "icon",
              type: "button",
              variant: "ghost",
              "aria-label": "Clear value",
              className: d(
                "ms-2 mr-1",
                o.value.length === 0 ? "opacity-0 pointer-events-none" : "opacity-100"
              ),
              title: "Clear value",
              onClick: () => o.onChange(""),
              children: /* @__PURE__ */ e.jsx(rt, { size: 16 })
            }
          )
        }
      )
    ] }) })
  ] }, s.id)) }) }) });
}, ja = (t, a) => {
  const s = u.forwardRef(({ className: r, asChild: o, ...l }, i) => {
    const p = o ? Dt : t;
    return u.createElement(p, {
      ...l,
      ref: i,
      className: d(a, r)
    });
  });
  return s.displayName = `VariantComponent(${t})`, s;
}, ba = ja(
  "input",
  "px-2 bg-transparent h-6 font-mono text-xs m-2"
), Na = ({
  control: t,
  queryParams: a
}) => {
  const { fields: s } = me({
    control: t,
    name: "queryParams"
  }), r = $e(), o = a.map((l) => !!l.isRequired);
  return /* @__PURE__ */ e.jsx(W, { className: "rounded-lg", children: /* @__PURE__ */ e.jsx("div", { className: "w-full ", children: s.map((l, i) => {
    const p = a.find(
      (c) => c.name === l.name
    );
    return /* @__PURE__ */ e.jsxs(
      "div",
      {
        className: "hover:bg-accent/40 grid grid-cols-[min-content_1fr_1fr] gap-2 items-center px-3",
        children: [
          /* @__PURE__ */ e.jsx(
            T,
            {
              control: t,
              name: `queryParams.${i}.active`,
              render: ({ field: c }) => /* @__PURE__ */ e.jsx(
                he,
                {
                  variant: "outline",
                  id: `queryParams.${i}.active`,
                  className: "mr-2",
                  checked: c.value,
                  onCheckedChange: c.onChange
                }
              )
            }
          ),
          /* @__PURE__ */ e.jsx(
            T,
            {
              control: t,
              render: ({ field: c }) => o[i] ? /* @__PURE__ */ e.jsx(ba, { asChild: !0, children: /* @__PURE__ */ e.jsxs(
                "label",
                {
                  className: "flex items-center cursor-pointer gap-1",
                  htmlFor: `queryParams.${i}.active`,
                  title: o[i] ? "Required field" : void 0,
                  children: [
                    c.value,
                    o[i] && /* @__PURE__ */ e.jsx("sup", { children: " *" })
                  ]
                }
              ) }) : /* @__PURE__ */ e.jsx(
                ce,
                {
                  value: c.value,
                  options: a.map((h) => h.name),
                  onChange: (h) => {
                    c.onChange(h);
                  },
                  className: "border-0 font-mono text-xs bg-transparent hover:bg-transparent"
                }
              ),
              name: `queryParams.${i}.name`
            }
          ),
          /* @__PURE__ */ e.jsx("div", { className: "flex justify-between items-center", children: /* @__PURE__ */ e.jsx(
            T,
            {
              control: t,
              render: ({ field: c }) => (p == null ? void 0 : p.enum) && p.enum.length > 0 ? /* @__PURE__ */ e.jsx(
                ce,
                {
                  value: c.value,
                  options: p.enum ?? [],
                  onChange: (g) => {
                    c.onChange(g), r.setValue(`queryParams.${i}.active`, !0);
                  },
                  className: "font-mono text-xs border-0 ring-1 ring-ring"
                }
              ) : /* @__PURE__ */ e.jsx(
                pe,
                {
                  ...c,
                  onChange: (g) => {
                    c.onChange(g.target.value), g.target.value.length > 0 && r.setValue(`queryParams.${i}.active`, !0);
                  },
                  placeholder: "Enter value",
                  className: "w-full border-0 shadow-none text-xs font-mono"
                }
              ),
              name: `queryParams.${i}.value`
            }
          ) })
        ]
      },
      l.id
    );
  }) }) });
}, wa = ({
  value: t,
  onChange: a,
  className: s,
  options: r,
  showChevrons: o = !0
}) => /* @__PURE__ */ e.jsxs("div", { className: "grid", children: [
  /* @__PURE__ */ e.jsx(
    "select",
    {
      className: d(
        "row-start-1 col-start-1 border border-input text-foreground px-2 py-1 pe-6",
        "rounded-md appearance-none bg-zinc-50 hover:bg-white dark:bg-zinc-800 hover:dark:bg-zinc-800/75",
        s
      ),
      value: t,
      onChange: a,
      children: r.map((l) => /* @__PURE__ */ e.jsx("option", { value: l.value, children: l.label }, l.value))
    }
  ),
  /* @__PURE__ */ e.jsx(
    "div",
    {
      className: d(
        !o && "hidden",
        "row-start-1 col-start-1 self-center justify-self-end relative end-2 pointer-events-none"
      ),
      children: /* @__PURE__ */ e.jsx(ot, { size: 14 })
    }
  )
] }), Ca = (t) => {
  var s;
  return (s = Object.entries({
    "application/json": "json",
    "text/json": "json",
    "text/html": "html",
    "text/css": "css",
    "text/javascript": "javascript",
    "application/xml": "xml",
    "application/xhtml+xml": "xhtml"
  }).find(
    ([r]) => t.includes(r)
  )) == null ? void 0 : s[1];
}, Sa = (t) => {
  const a = t.get("Content-Type") || "";
  return Ca(a);
}, Ta = (t) => {
  try {
    return JSON.stringify(JSON.parse(t), null, 2);
  } catch {
    return null;
  }
}, Pa = ({
  body: t = "",
  headers: a
}) => {
  const s = Sa(a), r = Ta(t), o = r || t, [l, i] = B(
    r ? "formatted" : "raw"
  );
  return /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-2", children: [
    /* @__PURE__ */ e.jsx(U, { className: "shadow-none", children: /* @__PURE__ */ e.jsx(
      qt,
      {
        language: l === "raw" ? r ? "plain" : s : "json",
        noBackground: !0,
        className: "overflow-x-auto p-4 text-xs max-h-[calc(83.333vh-180px)]",
        code: l === "raw" ? t : o
      }
    ) }),
    r && /* @__PURE__ */ e.jsx("div", { className: "flex justify-end", children: /* @__PURE__ */ e.jsx(
      wa,
      {
        value: l,
        onChange: (p) => i(p.target.value),
        options: [
          { value: "formatted", label: "Formatted" },
          { value: "raw", label: "Raw" }
        ]
      }
    ) })
  ] });
}, H = "__none", Ra = {
  200: "OK",
  201: "Created",
  202: "Accepted",
  204: "No Content",
  400: "Bad Request",
  401: "Unauthorized",
  403: "Forbidden",
  404: "Not Found",
  405: "Method Not Allowed",
  500: "Internal Server Error"
}, $a = ({
  server: t,
  servers: a,
  url: s,
  method: r,
  headers: o = [],
  queryParams: l = [],
  pathParams: i = [],
  defaultBody: p = "",
  examples: c
}) => {
  var ge, ye, ve, je;
  const { selectedServer: h, setSelectedServer: g } = Tt(), [, b] = ut(), { register: f, control: m, handleSubmit: y, watch: O, setValue: C, ...P } = Ct({
    defaultValues: {
      body: p,
      queryParams: l.map((n) => ({
        name: n.name,
        value: n.defaultValue ?? "",
        active: n.defaultActive ?? !1,
        enum: n.enum ?? []
      })).concat([
        {
          name: "",
          value: "",
          active: !1,
          enum: []
        }
      ]),
      pathParams: i.map((n) => ({
        name: n.name,
        value: n.defaultValue ?? ""
      })),
      headers: o.map((n) => ({
        name: n.name,
        value: n.defaultValue ?? "",
        active: n.defaultActive ?? !1
      })).concat([
        {
          name: "",
          value: "",
          active: !1
        }
      ]),
      identity: H
    }
  }), S = O(), R = Ke(), fe = V(!1);
  Re(() => {
    var w;
    if (fe.current) return;
    const n = (w = R.data) == null ? void 0 : w.at(0);
    n && (C("identity", n.id), fe.current = !0);
  }, [C, R.data]);
  const N = yt({
    mutationFn: async (n) => {
      var A, $;
      const w = Wt(h ?? t, s, n), q = performance.now(), _ = new Request(w, {
        method: r.toUpperCase(),
        headers: Object.fromEntries(
          n.headers.filter((v) => v.name && v.active).map((v) => [v.name, v.value])
        ),
        body: n.body ? n.body : void 0
      });
      n.identity !== H && (($ = (A = R.data) == null ? void 0 : A.find((v) => v.id === n.identity)) == null || $.authorizeRequest(_));
      try {
        const v = await fetch(_, {
          signal: AbortSignal.timeout(5e3)
        }), M = performance.now() - q, F = await v.text();
        return {
          status: v.status,
          headers: v.headers,
          size: F.length,
          body: F,
          time: M
        };
      } catch (v) {
        throw v instanceof TypeError ? new Error(
          "The request failed, possibly due to network issues or CORS policy."
        ) : v;
      }
    }
  }), Ue = s.split("/").map((n, w, q) => {
    var M;
    const _ = n.startsWith("{") && n.endsWith("}") || n.startsWith(":"), A = n.replace(/[:{}]/g, ""), $ = (M = S.pathParams.find((F) => F.name === A)) == null ? void 0 : M.value, v = /* @__PURE__ */ e.jsx(
      qe,
      {
        backgroundOpacity: "25%",
        name: n,
        slug: n,
        title: $ ? void 0 : `Missing value for path parameter \`${A}\``,
        children: $ ? encodeURIComponent($) : n
      }
    );
    return (
      // eslint-disable-next-line react/no-array-index-key
      /* @__PURE__ */ e.jsxs(ee, { children: [
        _ ? v : n,
        w < q.length - 1 && "/",
        /* @__PURE__ */ e.jsx("wbr", {})
      ] }, n + w)
    );
  }), K = Array.from(((ge = N.data) == null ? void 0 : ge.headers.entries()) ?? []), xe = S.queryParams.filter((n) => n.active).map((n, w, q) => /* @__PURE__ */ e.jsxs(ee, { children: [
    n.name,
    "=",
    encodeURIComponent(n.value).replaceAll("%20", "+"),
    w < q.length - 1 && "&",
    /* @__PURE__ */ e.jsx("wbr", {})
  ] }, n.name)), Be = /* @__PURE__ */ e.jsx("div", { className: "inline-block opacity-50 hover:opacity-100 transition", children: a && a.length > 1 ? /* @__PURE__ */ e.jsxs(
    vt,
    {
      onValueChange: (n) => {
        b(() => {
          g(n);
        });
      },
      value: h,
      defaultValue: h,
      children: [
        /* @__PURE__ */ e.jsx(jt, { className: "p-0 border-none flex-row-reverse bg-transparent text-xs gap-0.5 h-auto", children: /* @__PURE__ */ e.jsx(bt, {}) }),
        /* @__PURE__ */ e.jsx(Nt, { children: a.map((n) => /* @__PURE__ */ e.jsx(wt, { value: n, children: n.replace(/^https?:\/\//, "") }, n)) })
      ]
    }
  ) : /* @__PURE__ */ e.jsx("span", { children: t.replace(/^https?:\/\//, "") }) });
  return /* @__PURE__ */ e.jsx(
    St,
    {
      register: f,
      control: m,
      handleSubmit: y,
      watch: O,
      setValue: C,
      ...P,
      children: /* @__PURE__ */ e.jsx("form", { onSubmit: y((n) => N.mutateAsync(n)), children: /* @__PURE__ */ e.jsxs("div", { className: "grid grid-cols-[8fr_7fr] text-sm h-full", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-4 p-4 after:bg-muted-foreground/20 relative after:absolute after:w-px after:inset-0 after:left-auto", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "flex gap-2 items-stretch", children: [
            /* @__PURE__ */ e.jsxs("div", { className: "flex flex-1 items-center w-full border rounded-md", children: [
              /* @__PURE__ */ e.jsx("div", { className: "border-r p-2 bg-muted rounded-l-md self-stretch font-semibold font-mono flex items-center", children: r.toUpperCase() }),
              /* @__PURE__ */ e.jsxs("div", { className: "flex items-center flex-wrap p-2 font-mono text-xs", children: [
                Be,
                Ue,
                xe.length > 0 ? "?" : "",
                xe
              ] })
            ] }),
            /* @__PURE__ */ e.jsx(E, { type: "submit", className: "h-auto flex gap-1", children: "Send" })
          ] }),
          /* @__PURE__ */ e.jsxs(Ce, { defaultValue: "parameters", children: [
            /* @__PURE__ */ e.jsx("div", { className: "flex flex-wrap gap-1 justify-between", children: /* @__PURE__ */ e.jsxs(Se, { children: [
              /* @__PURE__ */ e.jsxs(k, { value: "parameters", children: [
                "Parameters",
                (S.pathParams.some((n) => n.value !== "") || S.queryParams.some((n) => n.active)) && /* @__PURE__ */ e.jsx("div", { className: "w-2 h-2 rounded-full bg-blue-400 ml-2" })
              ] }),
              /* @__PURE__ */ e.jsxs(k, { value: "headers", children: [
                "Headers",
                S.headers.filter((n) => n.active).length > 0 && /* @__PURE__ */ e.jsx("div", { className: "w-2 h-2 rounded-full bg-blue-400 ml-2" })
              ] }),
              /* @__PURE__ */ e.jsxs(k, { value: "auth", children: [
                "Auth",
                S.identity !== H && /* @__PURE__ */ e.jsx("div", { className: "w-2 h-2 rounded-full bg-blue-400 ml-2" })
              ] }),
              /* @__PURE__ */ e.jsx(k, { value: "body", children: "Body" })
            ] }) }),
            /* @__PURE__ */ e.jsx(I, { value: "headers", children: /* @__PURE__ */ e.jsx(ga, { control: m, register: f }) }),
            /* @__PURE__ */ e.jsxs(I, { value: "parameters", children: [
              i.length > 0 && /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-4 my-4", children: [
                /* @__PURE__ */ e.jsx("span", { className: "font-semibold", children: "Path Parameters" }),
                /* @__PURE__ */ e.jsx(va, { control: m })
              ] }),
              /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-4 my-4", children: [
                /* @__PURE__ */ e.jsx("span", { className: "font-semibold", children: "Query Parameters" }),
                /* @__PURE__ */ e.jsx(Na, { control: m, queryParams: l })
              ] })
            ] }),
            /* @__PURE__ */ e.jsxs(I, { value: "body", children: [
              !["POST", "PUT", "PATCH", "DELETE"].includes(
                r.toUpperCase()
              ) && /* @__PURE__ */ e.jsxs(oe, { className: "mb-2", children: [
                /* @__PURE__ */ e.jsx(we, { className: "w-4 h-4" }),
                /* @__PURE__ */ e.jsx(le, { children: "Body" }),
                /* @__PURE__ */ e.jsx(ie, { children: "Body is only supported for POST, PUT, PATCH, and DELETE requests" })
              ] }),
              /* @__PURE__ */ e.jsx(
                Ee,
                {
                  ...f("body"),
                  className: d(
                    "border w-full rounded-lg p-2 bg-muted h-40 font-mono",
                    !["POST", "PUT", "PATCH", "DELETE"].includes(
                      r.toUpperCase()
                    ) && "h-20"
                  ),
                  placeholder: ["POST", "PUT", "PATCH", "DELETE"].includes(
                    r.toUpperCase()
                  ) ? void 0 : "This request does not support a body",
                  disabled: !["POST", "PUT", "PATCH", "DELETE"].includes(
                    r.toUpperCase()
                  )
                }
              ),
              c && /* @__PURE__ */ e.jsx(
                sa,
                {
                  examples: c,
                  onSelect: (n) => C("body", JSON.stringify(n.value, null, 2))
                }
              )
            ] }),
            /* @__PURE__ */ e.jsx(I, { value: "auth", children: /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-4 my-4", children: [
              ((ye = R.data) == null ? void 0 : ye.length) === 0 && /* @__PURE__ */ e.jsxs(oe, { children: [
                /* @__PURE__ */ e.jsx(we, { className: "w-4 h-4" }),
                /* @__PURE__ */ e.jsx(le, { children: "Authentication" }),
                /* @__PURE__ */ e.jsx(ie, { children: "No identities found. Please create an identity first." })
              ] }),
              /* @__PURE__ */ e.jsx("div", { className: "flex flex-col items-center gap-2", children: /* @__PURE__ */ e.jsx(U, { className: "w-full overflow-hidden", children: /* @__PURE__ */ e.jsxs(
                Ie,
                {
                  onValueChange: (n) => C("identity", n),
                  value: S.identity,
                  defaultValue: S.identity,
                  className: "gap-0",
                  disabled: ((ve = R.data) == null ? void 0 : ve.length) === 0,
                  children: [
                    /* @__PURE__ */ e.jsxs(
                      D,
                      {
                        className: "h-12 border-b items-center flex p-4 cursor-pointer hover:bg-accent",
                        htmlFor: "none",
                        children: [
                          /* @__PURE__ */ e.jsx(de, { value: H, id: "none", children: "None" }),
                          /* @__PURE__ */ e.jsx(D, { htmlFor: "none", className: "ml-2", children: "None" })
                        ]
                      }
                    ),
                    (je = R.data) == null ? void 0 : je.map((n) => /* @__PURE__ */ e.jsxs(
                      D,
                      {
                        className: "h-12 border-b items-center flex p-4 cursor-pointer hover:bg-accent",
                        children: [
                          /* @__PURE__ */ e.jsx(
                            de,
                            {
                              value: n.id,
                              id: n.id,
                              children: n.label
                            }
                          ),
                          /* @__PURE__ */ e.jsx(D, { htmlFor: n.id, className: "ml-2", children: n.label })
                        ]
                      },
                      n.id
                    ))
                  ]
                }
              ) }) })
            ] }) })
          ] })
        ] }),
        /* @__PURE__ */ e.jsx("div", { className: "min-w-0 p-8 bg-muted/70", children: N.error ? /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-2", children: [
          S.pathParams.some((n) => n.value === "") && /* @__PURE__ */ e.jsx($t, { type: "caution", children: "Some path parameters are missing values. Please fill them in to ensure the request is sent correctly." }),
          /* @__PURE__ */ e.jsxs(U, { children: [
            /* @__PURE__ */ e.jsx(kt, { children: /* @__PURE__ */ e.jsx(It, { children: "Request failed" }) }),
            /* @__PURE__ */ e.jsxs(Et, { children: [
              "Error:",
              " ",
              N.error.message || String(N.error) || "Unexpected error"
            ] })
          ] })
        ] }) : N.data ? /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-2", children: [
          /* @__PURE__ */ e.jsx("div", { className: "flex gap-2", children: /* @__PURE__ */ e.jsxs("div", { className: "flex text-xs gap-6", children: [
            /* @__PURE__ */ e.jsxs("div", { children: [
              "Status: ",
              N.data.status,
              " ",
              Ra[N.data.status] ?? ""
            ] }),
            /* @__PURE__ */ e.jsxs("div", { children: [
              "Time: ",
              N.data.time.toFixed(0),
              "ms"
            ] }),
            /* @__PURE__ */ e.jsxs("div", { children: [
              "Size: ",
              N.data.size,
              " B"
            ] })
          ] }) }),
          /* @__PURE__ */ e.jsxs(Ce, { defaultValue: "response", children: [
            /* @__PURE__ */ e.jsxs(Se, { children: [
              /* @__PURE__ */ e.jsx(k, { value: "response", children: "Response" }),
              /* @__PURE__ */ e.jsx(k, { value: "headers", children: K.length ? `Headers (${K.length})` : "No headers" })
            ] }),
            /* @__PURE__ */ e.jsx(I, { value: "response", children: /* @__PURE__ */ e.jsx(
              Pa,
              {
                headers: N.data.headers,
                body: N.data.body
              }
            ) }),
            /* @__PURE__ */ e.jsx(I, { value: "headers", children: /* @__PURE__ */ e.jsxs(
              U,
              {
                className: "max-h-[calc(83.333vh-140px)] overflow-y-auto grid grid-cols-2 w-full gap-2.5 font-mono text-xs shadow-none p-4",
                children: [
                  /* @__PURE__ */ e.jsx("div", { className: "font-semibold", children: "Key" }),
                  /* @__PURE__ */ e.jsx("div", { className: "font-semibold", children: "Value" }),
                  K.map(([n, w]) => /* @__PURE__ */ e.jsxs(ee, { children: [
                    /* @__PURE__ */ e.jsx("div", { children: n }),
                    /* @__PURE__ */ e.jsx("div", { className: "break-words", children: w })
                  ] }, n))
                ]
              }
            ) })
          ] })
        ] }) : /* @__PURE__ */ e.jsx("div", { className: "grid place-items-center h-full", children: /* @__PURE__ */ e.jsx("span", { className: "text-[16px] font-semibold text-muted-foreground", children: N.isPending ? /* @__PURE__ */ e.jsx(Rt, {}) : "Send a request first to see the response here" }) }) })
      ] }) })
    }
  );
}, ka = ({
  className: t,
  size: a = 16
}) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    className: t,
    width: a,
    height: a,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm14.024-.983a1.125 1.125 0 0 1 0 1.966l-5.603 3.113A1.125 1.125 0 0 1 9 15.113V8.887c0-.857.921-1.4 1.671-.983l5.603 3.113Z",
        clipRule: "evenodd"
      }
    )
  }
), Ia = (t) => {
  const [a, s] = B(!1);
  return /* @__PURE__ */ e.jsxs(ht, { onOpenChange: (r) => s(r), children: [
    /* @__PURE__ */ e.jsx(ft, { asChild: !0, children: t.children ?? /* @__PURE__ */ e.jsxs("button", { className: "flex gap-1 items-center px-2 py-1 rounded-md transition text-xs bg-primary  text-primary-foreground shadow-sm hover:bg-primary/80", children: [
      "Test",
      /* @__PURE__ */ e.jsx(ka, { className: "", size: 14 })
    ] }) }),
    /* @__PURE__ */ e.jsxs(
      xt,
      {
        className: "max-w-screen-xl w-full h-5/6 overflow-auto p-0",
        "aria-describedby": void 0,
        children: [
          /* @__PURE__ */ e.jsx(mt, { children: /* @__PURE__ */ e.jsx(gt, { children: "Playground" }) }),
          a && /* @__PURE__ */ e.jsx($a, { ...t })
        ]
      }
    )
  ] });
}, Pe = Ht(`
  query GetCategories($input: JSON!, $type: SchemaType!) {
    schema(input: $input, type: $type) {
      url
      tags {
        __typename
        name
        operations {
          __typename
          slug
          deprecated
          method
          summary
          operationId
          path
        }
      }
    }
  }
`), Ea = {
  get: "green",
  post: "blue",
  put: "yellow",
  delete: "red",
  patch: "purple",
  options: "gray",
  head: "gray"
}, ss = (t) => {
  const a = Ne(t.navigationId ?? "/reference"), s = t.type === "file" ? Object.keys(t.input) : [], r = new Bt(t);
  return {
    getHead: () => {
      if (t.type === "url" && !t.skipPreload)
        return /* @__PURE__ */ e.jsx(
          "link",
          {
            rel: "preload",
            href: t.input,
            as: "fetch",
            crossOrigin: "anonymous"
          }
        );
      if (t.server)
        return /* @__PURE__ */ e.jsx("link", { rel: "preconnect", href: t.server });
    },
    getMdxComponents: () => ({
      OpenPlaygroundButton: ({
        requireAuth: o,
        server: l,
        method: i,
        url: p,
        ...c
      }) => {
        var b;
        const h = dt(), g = Ze({
          queryFn: () => r.fetch(Pe, {
            type: t.type,
            input: t.input
          }),
          enabled: !l,
          queryKey: ["playground-server"]
        });
        return o && !h.isAuthenticated ? /* @__PURE__ */ e.jsxs(
          E,
          {
            className: "gap-2 items-center",
            variant: "outline",
            onClick: h.login,
            children: [
              "Login to open in Playground ",
              /* @__PURE__ */ e.jsx(lt, { size: 16 })
            ]
          }
        ) : /* @__PURE__ */ e.jsx(
          Ia,
          {
            url: p ?? "/",
            method: i ?? "get",
            server: l ?? ((b = g.data) == null ? void 0 : b.schema.url) ?? "https://example.com",
            ...c,
            children: /* @__PURE__ */ e.jsxs(E, { className: "gap-2 items-center", variant: "outline", children: [
              "Open in Playground ",
              /* @__PURE__ */ e.jsx(it, { size: 16 })
            ] })
          }
        );
      }
    }),
    getSidebar: async (o) => {
      if (!We({ path: a, end: !1 }, o))
        return [];
      try {
        const l = s.find((c) => o === Ne(a, c)) ?? Object.keys(t.input).at(0), p = (await r.fetch(Pe, {
          type: t.type,
          input: t.type === "file" ? t.input[l] : t.input,
          version: l
        })).schema.tags.filter((c) => c.operations.length > 0).map((c) => ({
          type: "category",
          label: c.name || "Other endpoints",
          collapsible: !0,
          collapsed: !1,
          items: c.operations.map((h) => ({
            type: "link",
            label: h.summary ?? h.path,
            href: `#${h.slug}`,
            badge: {
              label: h.method,
              color: Ea[h.method.toLowerCase()],
              invert: !0
            }
          }))
        }));
        return p.unshift({
          type: "link",
          label: "Overview",
          href: "#description"
        }), p;
      } catch {
        return [];
      }
    },
    getRoutes: () => [null, ...s].map((l) => ({
      path: a + (l ? `/${l}` : ""),
      async lazy() {
        const { OpenApiRoute: i } = await import("./Route-VdmEyOD0.js");
        return {
          element: /* @__PURE__ */ e.jsx(
            i,
            {
              basePath: a,
              versions: s,
              client: r,
              config: t
            }
          )
        };
      },
      children: [
        {
          index: !0,
          async lazy() {
            const { OperationList: i } = await import("./OperationList-DGJWDx1G.js");
            return { element: /* @__PURE__ */ e.jsx(i, {}) };
          }
        }
      ]
    }))
  };
};
export {
  qe as C,
  Ia as P,
  wa as S,
  Ht as g,
  ss as o
};
//# sourceMappingURL=index-CXRrqOIl.js.map
